import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFileExcel,FaFilePdf, FaPlus, FaSearch, FaUserFriends, FaUserTie, FaBan, FaExclamationTriangle } from 'react-icons/fa';
import { MdDelete, MdEdit, MdClose, MdBlock, MdHistory } from 'react-icons/md';
import styles from "./clientes.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalClientes from './clientesModal';
import BannedListModal from './bannedListModal';
import { MdOutlinePayments } from "react-icons/md";
import { AiOutlineUserSwitch } from 'react-icons/ai';
import { FaUserGroup } from 'react-icons/fa6';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { downloadPDFFromBase64, isMobileDevice, openPDFInNewWindow } from '../../utils/downloadUtils';



export default function Clientes(props) {
    const { windowSize, setClientActual, setMenuActual, permisos } = useAuth();
    const isReadOnlyMode = permisos.findIndex(item => item.identifier === "ClientReadMode") !== -1;

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [coordinadores, setCoordinadores] = useState([]);
    const [asesores, setAsesores] = useState([]);
    const [maritalEstatus, setMaritalEstatus] = useState([]);
    const [addressTypes, setAddressTypes] = useState([]);
    const [genders, setGenders] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [questions, setQuestions] = useState([]);
    const [textSearch, setTextSearch] = useState("");
    const [textSearchPrev, setTextSearchPrev] = useState("");
    const [asesorSelect, setAsesorSelect] = useState(null);
    const [asesorFilterSelect, setAsesorFilterSelect] = useState(null);
    const [showChangeAdvi, setShowChangeAdvi] = useState(false);
    const [showBannedList, setShowBannedList] = useState(false);
    const [clientsForBannedList, setClientsForBannedList] = useState([]);
    const [showRemoveFromBanned, setShowRemoveFromBanned] = useState(false);
    const [clientToRemoveFromBanned, setClientToRemoveFromBanned] = useState(null);
    const [removeMessage, setRemoveMessage] = useState('');
    const [showHistoryRemove, setShowHistoryRemove] = useState(false);
    const [historyDataRemove, setHistoryDataRemove] = useState([]);
    const [loadingHistoryRemove, setLoadingHistoryRemove] = useState(false);

    const { estados, municipios, codigos, documentTypes, referenceTypes } = useAuth();

    const columns = [
        {
            name: '',
            cell: (row) => {
                const isEmployee = row.typeClient === "EMP";
                const isBanned = row.banned === true;
                return (
                    <div style={{
                        display: "flex",
                        position: 'sticky',
                        left: 0,
                        background: isEmployee ? "#f8f9ff" : "white",
                        zIndex: "1",
                        padding: "2px"
                    }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        {!isReadOnlyMode && (
                            <>
                                <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.clientName, row.clientId)}><MdDelete /></button>&nbsp;
                            </>
                        )}
                        <button className='btn btn-sm btn-warning' onClick={() => handlePrestamos(row.clientName, row.clientId, row.typeClient)}><MdOutlinePayments /></button>&nbsp;
                        {!isReadOnlyMode && (
                            <>
                                {isBanned ? (
                                    <button 
                                        className='btn btn-sm btn-success' 
                                        onClick={() => handleRemoveFromBannedList(row)} 
                                        title="Quitar de lista negra"
                                    >
                                        <FaBan />
                                    </button>
                                ) : (
                                    <button 
                                        className='btn btn-sm' 
                                        style={{backgroundColor: '#dc3545', color: 'white'}} 
                                        onClick={() => handleAddToBannedList([row])} 
                                        title="Agregar a lista negra"
                                    >
                                        <MdBlock />
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                )
            },
            width: "150px",

        },
        {
            name: 'ID',
            selector: row => row.clientId,
            width: "70px",
        },
        {
            name: 'Nombre',
            cell: (row) => {
                // Verificar si el cliente tiene historial de lista negra
                const hasBlacklistHistory = row.hasBeenInBannedList === true;
                
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {row.typeClient === "EMP" && (
                            <FaUserTie
                                style={{
                                    color: '#6f42c1',
                                    fontSize: '16px',
                                    flexShrink: 0
                                }}
                                title="Empleado"
                            />
                        )}
                        {row.banned && (
                            <FaBan
                                style={{
                                    color: '#dc3545',
                                    fontSize: '16px',
                                    flexShrink: 0
                                }}
                                title="En lista negra"
                            />
                        )}
                        {!row.banned && hasBlacklistHistory && (
                            <FaExclamationTriangle
                                style={{
                                    color: '#ffc107',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                    cursor: 'pointer'
                                }}
                                title="Estuvo en lista negra anteriormente"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleShowClientHistory(row);
                                }}
                            />
                        )}
                        <span style={{ wordBreak: 'break-word' }}>
                            {row.clientName}
                        </span>
                    </div>
                );
            },
            flex: "1",
            minWidth: "200px",
            wrap: true
        },
        {
            name: 'Asesor',
            selector: row => row.advisorName,
            flex: "1",
            minWidth: "200px",
            wrap: true
        },
        {
            name: 'Dirección',
            selector: row => row.address,
            flex: "1",
            minWidth: "150px",
            wrap: true
        },
        {
            name: 'Teléfono',
            selector: row => row.stateName,
            flex: "1",
            minWidth: "100px",
            wrap: true
        },

        {
            name: 'Estatus',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <span className={row.status ? "badge bg-success" : "badge bg-danger"}>{row.status ? "Activo" : "Inactivo"}</span>
                    </div>
                )
            },
            width: "174px",
        },

    ];
    const handleChangeAdvi = async () => {
        if (isReadOnlyMode) return;

        if (asesorSelect === null) {
            Swal.fire("Selecciona un asesor", "", "warning");
            return;
        }
        if (selectedRows.length === 0) {
            Swal.fire("Selecciona al menos un cliente", "", "warning");
            return;
        }
        for (let index = 0; index < selectedRows.length; index++) {
            const client = selectedRows[index];
            await api(SERVICE.changeAdvisor + `?clientId=${client.clientId}&NewAdvisor=${asesorSelect.value}&OldAdvisor=${client.advisorId}`)
                .then((data) => {

                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {

                })
        }
        Swal.fire("Clientes actualizados correctamente", "", "success");
        setShowChangeAdvi(false);
        setAsesorSelect(null);
        handleClearRows();
        handleUpdateNosearch();
    }
    
    const handleAddToBannedList = (clients) => {
        if (isReadOnlyMode) return;
        setClientsForBannedList(clients);
        setShowBannedList(true);
    }

    const handleBannedListSuccess = () => {
        handleClearRows();
        handleUpdateNosearch();
    }
    
    const handleAddSelectedToBannedList = () => {
        if (isReadOnlyMode) return;
        if (selectedRows.length === 0) {
            Swal.fire("Selecciona al menos un cliente", "", "warning");
            return;
        }
        handleAddToBannedList(selectedRows);
    }
    
    const handleRemoveFromBannedList = (client) => {
        if (isReadOnlyMode) return;
        setClientToRemoveFromBanned(client);
        setRemoveMessage('');
        setShowRemoveFromBanned(true);
    }

    const handleConfirmRemoveFromBanned = async () => {
        if (isReadOnlyMode) return;
        if (!clientToRemoveFromBanned) return;

        try {
            const currentDate = new Date().toISOString().split('T')[0];
            const payload = {
                ClientId: clientToRemoveFromBanned.clientId,
                Banned: false,
                ReasonsBannedListId: null,
                Date: currentDate,
                Message: removeMessage.trim()
            };

            await api(SERVICE.setBannedListClient, payload, 'POST');
            Swal.fire('Éxito', 'Cliente removido de la lista negra', 'success');
            setShowRemoveFromBanned(false);
            setClientToRemoveFromBanned(null);
            setRemoveMessage('');
            handleUpdateNosearch();
        } catch (error) {
            console.error('Error al remover de lista negra:', error);
            Swal.fire('Error', 'No se pudo completar la operación', 'error');
        }
    }

    const loadHistoryRemove = async (clientId) => {
        setLoadingHistoryRemove(true);
        try {
            const response = await api(SERVICE.getBannedListHistory + `?clientId=${clientId}`);
            if (response.data.data) {
                setHistoryDataRemove(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar historial:', error);
            Swal.fire('Error', 'No se pudo cargar el historial', 'error');
        } finally {
            setLoadingHistoryRemove(false);
        }
    };

    const handleShowHistoryRemove = () => {
        if (clientToRemoveFromBanned) {
            loadHistoryRemove(clientToRemoveFromBanned.clientId);
            setShowHistoryRemove(true);
        }
    };

    const handleShowClientHistory = async (client) => {
        setLoadingHistoryRemove(true);
        setShowHistoryRemove(true);
        try {
            const response = await api(SERVICE.getBannedListHistory + `?clientId=${client.clientId}`);
            if (response.data.data) {
                setHistoryDataRemove(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar historial:', error);
            Swal.fire('Error', 'No se pudo cargar el historial', 'error');
        } finally {
            setLoadingHistoryRemove(false);
        }
    };
    
    const handlePrestamos = (userName, userId, typeClient) => {
        setClientActual({
            Id: userId,
            Name: userName,
            typeClient: typeClient
        });
        setMenuActual("prestamo2");
    }
    const handleDelete = (userName, userId) => {
        if (isReadOnlyMode) {
            Swal.fire({
                position: "center",
                icon: "info",
                title: "Solo visualización",
                text: "No tiene permitido modificar clientes",
                showConfirmButton: true
            });
            return;
        }

        const tienePermisoEliminar = permisos.findIndex(item => item.identifier === "ClientReadMode") !== -1;
        if(tienePermisoEliminar){
        Swal.fire({
            title: "Esta segur@ que desea eliminar el cliente " + userName + "?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                api(SERVICE.detelePersonalData + `?PersonalDataId=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });
        }else{
                         Swal.fire({
                                    position: "center",
                                    icon: "info",
                                    title: "Sin permisos",
                                    text: "No tiene permisos para eliminar clientes",
                                    showConfirmButton: true
                                });
            }
    }

    const handleGetOffice = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId
                        });

                    }
                }
                setOfices(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetQuestions = () => {
        api(SERVICE.getQuestionsByArea + "CLT_WARRANTY")
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);

                    }
                }
                setQuestions(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetAsesortes = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName
                        });

                    }
                }
                setAsesores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetAddressType = () => {
        api(SERVICE.getTiposVivienda)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setAddressTypes(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetCoordinadores = () => {
        api(SERVICE.getCordinadoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId,
                            postalCodeId: element.postalCodeId,
                            centralOfficeId: element.centralOfficeId
                        });

                    }
                }
                setCoordinadores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetMarital = () => {
        api(SERVICE.getMaritalEstatus)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setMaritalEstatus(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetGenders = () => {
        api(SERVICE.getGenders)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setGenders(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleSearch = () => {
        let URL = SERVICE.getPersonal + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (textSearch !== "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        if (asesorFilterSelect && asesorFilterSelect.value) {
            URL = URL + `&AdvisorId=${asesorFilterSelect.value}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data && data.data && data.data.paginationInfo) {
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push(element);
                        if (userEdit != null) {
                            if (userEdit.clientId === element.clientId) {
                                setUserEdit(element);
                            }
                        }

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    };

    const handleUpdate = () => {
        let URL = SERVICE.getPersonal + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (asesorFilterSelect && asesorFilterSelect.value) {
            URL = URL + `&AdvisorId=${asesorFilterSelect.value}`;
        }
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data && data.data && data.data.paginationInfo) {
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push(element);
                        if (userEdit != null) {
                            if (userEdit.clientId === element.clientId) {
                                setUserEdit(element);
                            }
                        }

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    };
    const handleUpdateNosearch = () => {
        let URL = SERVICE.getPersonal + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (asesorFilterSelect && asesorFilterSelect.value) {
            URL = URL + `&AdvisorId=${asesorFilterSelect.value}`;
        }
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data && data.data && data.data.paginationInfo) {
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push(element);

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    };


    const handleDownloadClientReport = async () => {
        if (selectedRows.length === 0) {
            selectedRows.push({
                id: 0,
                clientName: "Formato_Vacio"
            })
        }

        for (let index = 0; index < selectedRows.length; index++) {
            const element = selectedRows[index];
            await api(SERVICE.getReportClient + `?clientId=${element.clientId}`)
                .then((data) => {

                    if (data.data.data) {
                        const info = data.data.data;
                        const link = document.createElement('a');

                        // Cambiar el tipo MIME para PDF
                        link.href = `data:application/pdf;base64,${info}`;

                        // Cambiar la extensión del archivo a .pdf
                        link.download = "Reporte_" + element.clientName + ".pdf";

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {

                })
        }

    }

     const handleDownloadReportAddressData = () => {
         let URL = SERVICE.getReportClientAddress
          if (asesorFilterSelect && asesorFilterSelect.value) {
            URL = URL + `?AdvisorId=${asesorFilterSelect.value}`;
        }
                api(URL)
                    .then((data) => {
                        if (data.data.data) {
                            const info = data.data.data;
                            const fileName = "Reporte_DireccionesClientes.xlsx";
                            
                            const success = downloadPDFFromBase64(info, fileName);
                            
                            if (!success && isMobileDevice()) {
                                openPDFInNewWindow(info);
                            }
                        } 
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error al descargar el reporte",
                            text: "Inténtalo de nuevo",
                            showConfirmButton: true
                        });
                    })
                    .finally(() => {
                      
                    })
            
        }

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    const handleClearRows = () => {
        setToggleCleared(!toggleCleared);
        setSelectedRows([]);
    };


    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        if (codigos.length > 0 && municipios.length > 0 && ofices.length > 0 && estados.length > 0 && coordinadores.length > 0) {
            // Llamar directamente para evitar dependencia de función
            let URL = SERVICE.getPersonal + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
            if (asesorFilterSelect && asesorFilterSelect.value) {
                URL = URL + `&AdvisorId=${asesorFilterSelect.value}`;
            }
            api(URL)
                .then((data) => {
                    let arrayTemp = [];
                    if (data && data.data && data.data.paginationInfo) {
                        setTotalRows(data.data.paginationInfo.totalRecords);
                    }
                    if (data.data.data) {
                        for (let index = 0; index < data.data.data.length; index++) {
                            const element = data.data.data[index];
                            arrayTemp.push(element);
                        }
                    }
                    setDataTable(arrayTemp);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [ofices, coordinadores, page, perPage, asesorFilterSelect, codigos.length, municipios.length, estados.length])
    useEffect(() => {
        handleGetOffice();
        handleGetCoordinadores();
        handleGetMarital();
        handleGetGenders();
        handleGetAsesortes();
        handleGetQuestions();
        handleGetAddressType();
    }, [])
    useEffect(() => {
        console.log("selectedRows", selectedRows)
    }, [selectedRows])

    // Estilos condicionales para diferenciar empleados y clientes en lista negra
    const conditionalRowStyles = [
        {
            when: row => row.banned === true,
            style: {
                backgroundColor: '#ffe6e6',
                borderLeft: '4px solid #dc3545',
                '&:hover': {
                    backgroundColor: '#ffcccc',
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.typeClient === "EMP" && !row.banned,
            style: {
                backgroundColor: '#f8f9ff',
                borderLeft: '4px solid #6f42c1',
                '&:hover': {
                    backgroundColor: '#e7e8ff',
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.typeClient === "CLT" && !row.banned,
            style: {
                borderLeft: '4px solid #ffffffff',
            },
        },
    ];

    return (
        <>
            <WindowLayout
                title="CLIENTES"
                route={["Prestamos", "Clientes"]}
                actions={[() => setMenuActual("prestamoMenu")]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>



                    <div style={{ display: "flex", justifyContent: "left", alignItems: "center", flexWrap: "wrap", margin: "10px 0" }}>
                        <div className={styles.itemForm} style={{ zIndex: 7, marginRight: "15px",width:"33%" }}>
                            <label className="form-label">Asesor: </label>
                            <Select
                                isClearable
                                options={asesores}
                                className=""
                                placeholder="Seleccionar Asesor"
                                value={asesorFilterSelect}
                                onChange={(e) => setAsesorFilterSelect(e)}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        minWidth: '250px'
                                    })
                                }}
                            />
                        </div>
                    </div>


                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                        <div className={`input-group flex-nowrap ${styles.searchContainer}`}>
                            <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                            <button className='btn btn-primary' onClick={handleSearch}><FaSearch /></button>
                        </div>
                        <div style={{ zIndex: 2, paddingTop: "", display: "flex", justifyContent: "flex-end", width: "50%" }}>

                            {!isReadOnlyMode && (
                                <button className='btn btn-success mx-1' title="Agregar cliente" onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                            )}
                            {!isReadOnlyMode && (permisos.findIndex(item => item.identifier === "ChangeAdvisorClt") !== -1) ?
                                <button disabled={selectedRows.length === 0} className='btn btn-warning mx-1' title="Cambio de Asesor" onClick={() => setShowChangeAdvi(!showChangeAdvi)}><FaUserGroup /></button>
                                :
                                <></>
                            }
                            {!isReadOnlyMode && (
                                <button disabled={selectedRows.length === 0} className='btn btn-danger mx-1' title="Agregar a lista negra" onClick={handleAddSelectedToBannedList}><MdBlock /></button>
                            )}
                            <button disabled={selectedRows.length === 0} className='btn btn-success mx-1' title="Reporte cliente" style={{ color: "white", backgroundColor: "#0066cc", borderColor: "#0066cc" }} onClick={() => handleDownloadClientReport()}> <FaFilePdf /></button>
                              <button onClick={handleDownloadReportAddressData} className='btn btn-info'><FaFileExcel></FaFileExcel>&nbsp; Direcciones</button>
                        </div>
                    </div>
                    <div style={{ display: textSearchPrev !== "" ? "flex" : "none", width: "50%" }}>
                        <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                        }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        conditionalRowStyles={conditionalRowStyles}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[50, 70, 100, 150, 200]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                        selectableRows={!isReadOnlyMode}
                        selectableRowsHighlight={!isReadOnlyMode}
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleCleared}
                    />

                </div>
            </WindowLayout>
            <ModalClientes
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                handleUpdate={handleUpdateNosearch}
                municipios={municipios}
                estados={estados}
                codigos={codigos}
                ofices={ofices}
                coordinadores={coordinadores}
                maritalEstatus={maritalEstatus}
                genders={genders}
                asesores={asesores}
                addressTypes={addressTypes}
                documentTypes={documentTypes}
                referenceTypes={referenceTypes}
                questions={questions}
                isReadOnlyMode={isReadOnlyMode}
            />
            <Modal show={!isReadOnlyMode && showChangeAdvi} onHide={() => setShowChangeAdvi(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Cambio de asesor</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="form-label">Selecciona el nuevo asesor:</label>
                            <Select options={asesores} class="form-control" placeholder="Asesor" value={asesorSelect} onChange={(e) => setAsesorSelect(e)} />

                        </div>
                        <div className="col-12 mb-3">
                            <div>
                                <b>Clientes seleccionados: </b> {selectedRows.length}
                                {
                                    selectedRows.map((item, index) => (
                                        <div key={index}>
                                            {(index + 1) + ".- " + item.clientName}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowChangeAdvi(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={() => handleChangeAdvi()}>
                        Aceptar
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {!isReadOnlyMode && (
                <BannedListModal
                    show={showBannedList}
                    setShow={setShowBannedList}
                    selectedClients={clientsForBannedList}
                    onSuccess={handleBannedListSuccess}
                />
            )}

            <Modal 
                show={!isReadOnlyMode && showRemoveFromBanned && !showHistoryRemove} 
                onHide={() => setShowRemoveFromBanned(false)} 
                size="md" 
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Quitar de Lista Negra</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <div className="alert alert-info d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>Cliente:</strong> {clientToRemoveFromBanned?.clientName}
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-info"
                                    onClick={handleShowHistoryRemove}
                                    title="Ver historial"
                                >
                                    <MdHistory /> Historial
                                </button>
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <label className="form-label fw-bold">Mensaje (opcional)</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Ingrese el motivo de la remoción de lista negra..."
                                value={removeMessage}
                                onChange={(e) => setRemoveMessage(e.target.value)}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRemoveFromBanned(false)}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={handleConfirmRemoveFromBanned}>
                        Quitar de Lista Negra
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Historial para Remover */}
            <Modal 
                show={!isReadOnlyMode && showHistoryRemove} 
                onHide={() => {
                    setShowHistoryRemove(false);
                    setHistoryDataRemove([]);
                }} 
                size="lg" 
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Historial de Lista Negra {clientToRemoveFromBanned ? `- ${clientToRemoveFromBanned.clientName}` : ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingHistoryRemove ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Cargando...</span>
                            </div>
                        </div>
                    ) : historyDataRemove.length === 0 ? (
                        <div className="alert alert-info">
                            No hay historial disponible para este cliente
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Fecha</th>
                                        <th>Acción</th>
                                        <th>Razón</th>
                                        <th>Usuario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historyDataRemove.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{new Date(item.date).toLocaleDateString('es-MX')}</td>
                                            <td>
                                                {item.banned ? (
                                                    <span className="badge bg-danger">Agregado a lista negra</span>
                                                ) : (
                                                    <span className="badge bg-success">Removido de lista negra</span>
                                                )}
                                            </td>
                                            <td>{item.description || '-'}</td>
                                            <td>{item.userName}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowHistoryRemove(false);
                        setHistoryDataRemove([]);
                    }}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
} 